import { useCallback, useContext } from 'react';

import { RouteContext } from 'src/context';
import history from 'src/history';

export type ModalType = 'app-settings';

export function useImmersiveModalParams() {
  const { query } = useContext(RouteContext);
  const { modal: modalType, moduleType, moduleId, appId, appName } = query;

  const open = useCallback(
    (type: ModalType, params?: Record<string, string>) => {
      const existing = new URLSearchParams(history.location.search);
      Object.entries({ modal: type, ...params }).forEach(([k, v]) =>
        existing.set(k, v),
      );
      history.replace({ search: existing.toString() });
    },
    [],
  );

  const close = useCallback(() => {
    const params = new URLSearchParams(history.location.search);
    params.delete('modal');
    params.delete('moduleType');
    params.delete('moduleId');
    params.delete('appId');
    params.delete('appName');
    history.replace({ search: params.toString() });
  }, []);

  return {
    modalType,
    moduleType,
    moduleId,
    appId,
    appName,
    open,
    close,
  };
}
